import { FunctionComponent, useCallback } from "react";
import { Menu as AntMenu } from "antd";

interface MenuItem {
  label: string;
  key: string;
  danger?: boolean;
}

interface MenuProps {
  items: MenuItem[];
  onSelect?: (key: string, selectedKeys: string[]) => void;
}

const Menu: FunctionComponent<MenuProps> = ({ items, onSelect }) => {
  const handleSelect = useCallback(
    (info: { key: string; selectedKeys: string[] }) => {
      onSelect?.(info.key, info.selectedKeys);
    },
    [onSelect],
  );

  return (
    <AntMenu
      items={items}
      selectedKeys={[]}
      onSelect={handleSelect}
      style={{
        borderRadius: "8px",
        maxHeight: "50vh",
        overflow: "auto",
      }}
    />
  );
};

export { Menu };
export type { MenuItem };
